<template>
  <div class="c-placement">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border"
    >
      {{ translationsPlacement.sectionName }}
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-20"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <span
            class="o-label"
            :title="translationsPlacement.placement || ''"
            >{{ translationsPlacement.placement || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--12">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="placedIndoors"
            mutable-name="value"
            v-model="placement.placedIndoors"
            :initialValue="
              placement.placedIndoors
                ? translationsPlacement.placedIndoors
                : placement.placedIndoors === null
                ? ''
                : translationsPlacement.placedOutdoors
            "
            :options="placementOptions"
            :textAligned="true"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-20"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <span
            class="o-label"
            :title="translationsPlacement.description || ''"
            >{{ translationsPlacement.description || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--12">
          <CallCenterAEDeditableTextArea
            :section="section"
            name="description"
            v-model="placement.description"
            :initialValue="(placement && placement.description) || ''"
            :textAligned="true"
            :maxLength="1023"
          ></CallCenterAEDeditableTextArea>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-40"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <span class="o-label" :title="translationsPlacement.comment || ''">{{
            translationsPlacement.comment || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--12">
          <CallCenterAEDeditableTextArea
            :section="section"
            name="comment"
            v-model="placement.comment"
            :initialValue="(placement && placement.comment) || ''"
            :textAligned="true"
            :maxLength="1023"
          ></CallCenterAEDeditableTextArea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-placement",
  data() {
    return {
      section: "placement",
      name: "Placement"
    };
  },
  computed: {
    ...mapGetters("aed", ["parameters", "placement"]),
    ...mapState("aed", ["loading"]),
    ...mapState("translations", {
      translationsPlacement: "placement"
    }),

    placementOptions() {
      const placementOptions = [
        {
          name: this.translationsPlacement.placedIndoors || "",
          value: true
        },
        {
          name: this.translationsPlacement.placedOutdoors || "",
          value: false
        }
      ];
      return placementOptions;
    }
  }
};
</script>

<style lang="scss">
.c-placement {
}
</style>
